import { useRouter } from "next/navigation";
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faTimes,
  faCaretRight,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";

const SearchBar = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const router = useRouter();
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    console.log("Search term:", event.target.value);
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    console.log("Search submitted:", searchTerm);
  };
  const handleSearch = () => {
    router.push("/searchResult");
  };

  return (
    <form onSubmit={handleSubmit} className="flex items-center relative">
      <input
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleInputChange}
        className="w-full px-4 h-6 border hidden border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm md:rounded-l-md"
      />
      <div className="absolute right-2 top-1/2 transform -translate-y-1/2 md:static md:inset-y-0 md:translate-y-0">
        <button
          type="submit"
          className="text-gray-400 hover:text-gray-500 focus:outline-none ml-3"
          onClick={handleSearch}
        >
          <FontAwesomeIcon
            icon={faSearch}
            className="h-3 w-4 text-[#3A5A40] mt-2"
          />
        </button>
      </div>
    </form>
  );
};
export default SearchBar;
